// extracted by mini-css-extract-plugin
export default {"button":"elq63kwZEMXqBUoBMUMR","disabled":"Xc3SNAJRuDQt2n3jd9gF"};